module.exports = __webpack_public_path__ + "img/hidden-gold.91145b1d.png";